<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import autofit from "autofit.js";
export default {
  name: 'App',
  data() {
    return {
      removeUpdateDownloadListener: null
    }
  },
  mounted() {
    autofit.init({
      designHeight: 1080,
      designWidth: 1920,
      renderDom: "#content-container", // 【关键】只缩放内容区，不缩放外壳
      resize: true
    });
    // 1. 初始化：应用启动时，从 Vuex 读取并设置一次 CSS 变量
    this.initGlobalStyle();
    this.initUpdateDownloadListener();
    window.addEventListener('keydown', this.handleGlobalShortcut);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleGlobalShortcut);
    if (this.removeUpdateDownloadListener) {
      this.removeUpdateDownloadListener();
    }
  },
  computed: {
    // 监听 Vuex 中的字号变化
    globalFontSize() {
      return this.$store.state.systems.globalFontSize;
    }
  },
  watch: {
    // 2. 响应：当 Vuex 中的字号发生变化时，实时更新根节点样式
    globalFontSize(newSize) {
      document.documentElement.style.setProperty('--global-font-size', newSize + 'px');
    }
  },
  methods: {
    initGlobalStyle() {
      const size = this.globalFontSize || 30;
      document.documentElement.style.setProperty('--global-font-size', size + 'px');
    },
    initUpdateDownloadListener() {
      if (!window.electronAPI || !window.electronAPI.onUpdateDownloadProgress) {
        return;
      }

      this.removeUpdateDownloadListener = window.electronAPI.onUpdateDownloadProgress((progress) => {
        this.$store.dispatch('appUpdate/setDownloadProgress', progress);
      });
    },
    handleGlobalShortcut(event) {
      if (event.key !== 'F2') {
        return;
      }

      event.preventDefault();
      window.dispatchEvent(new CustomEvent('open-system-settings'));
    }
  }
}
</script>

<style>
@import "./common/common.css";
/* 这里的样式是全局生效的，不要加 scoped */

html, body {
  margin: 0;
  padding: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden; /* 核心：防止缩放导致的滚动条 */

  -webkit-user-select: none;  /* Chrome, Safari, Opera */
  -moz-user-select: none;     /* Firefox */
  -ms-user-select: none;      /* IE 10+ */
  user-select: none;          /* Standard syntax */


  /* 字体设置：确保在 Win7 也是最清晰的 */
  font-family: "Microsoft YaHei", "微软雅黑", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;

  background-color: #f4f3ef;

  font-size: var(--global-font-size, 35px);

}

#app {
  width: 100%;
  height: 100%;
}

a {
  text-decoration: none;
}
.flash {
  color: red;
  font-weight: bold;
  font-size: calc(var(--global-font-size, 35px) * 1.15);
  padding: 0 8px;
  animation: blink 1s infinite;
}
.flash2 {
  color: #7d1fac;
  font-weight: bold;
  font-size: calc(var(--global-font-size, 35px) * 1.15);
  padding: 0 8px;

}
/**animation: blink 1s infinite;*/
@keyframes blink {
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}
.option-tag-key {
  font-size: 20px;
  background-color: blue;
  padding: 8px 8px;
  border-radius: 6px;
  color: #ffffff;
}
.timu-type1 {
  font-size: var(--global-font-size);
  font-weight: 600;
  letter-spacing: 2px;
}
.timu-type2 {
  color: blue;
  font-size: var(--global-font-size);
  font-weight: 600;
  letter-spacing: 2px;
}
.timu-type3 {
  color: #e65757;
  font-size: var(--global-font-size);
  font-weight: 600;
  letter-spacing: 2px;
}


/* 只针对加了 large-confirm-box 类名的弹窗生效 */
.large-confirm-box {
  width: 800px !important;
}
.large-confirm-box .el-message-box__title {
  font-size: 32px !important;
}
.large-confirm-box .el-message-box__message {
  font-size: 28px !important;
  padding: 30px;
}
.large-confirm-box .el-button {
  font-size: 24px !important;
  padding: 12px 30px !important;
}
.large-confirm-box .el-message-box__input input {
  height: 52px !important;
  line-height: 52px !important;
  font-size: 22px !important;
  font-weight: 700 !important;
}
.large-confirm-box .el-message-box__input .el-input__inner {
  height: 52px !important;
  line-height: 52px !important;
  font-size: 22px !important;
  font-weight: 700 !important;
}
.large-confirm-box .el-message-box__errormsg {
  font-size: 18px !important;
  margin-top: 8px !important;
}
/* 一键删除考试记录：长文案弹窗单独优化，避免换行后文字重叠 */
.large-confirm-box.clear-paper-records-confirm {
  width: 900px !important;
}
.large-confirm-box.clear-paper-records-confirm .el-message-box__content {
  padding: 24px 30px 20px !important;
}
.large-confirm-box.clear-paper-records-confirm .el-message-box__message {
  padding: 8px 12px 8px 44px !important;
  font-size: 26px !important;
  line-height: 1.6 !important;
  word-break: break-word;
  white-space: normal;
}
.large-confirm-box.clear-paper-records-confirm .el-message-box__message p {
  margin: 0 !important;
  line-height: 1.6 !important;
}
/* PC 公告 Notification 弹窗 — 放大字号便于阅读，cursor 提示可点击 */
.pc-notice-notify {
  cursor: pointer;
  width: 420px !important;
}
.pc-notice-notify .el-notification__title {
  font-size: 22px !important;
  font-weight: 700 !important;
}
.pc-notice-notify .el-notification__content p {
  font-size: 18px !important;
  line-height: 1.6 !important;
}

/* 删除文件夹弹窗：确认按钮用红色 */
.large-confirm-box.delete-folder-box .el-button--primary {
  background-color: #f56c6c !important;
  border-color: #f56c6c !important;
}
.large-confirm-box.delete-folder-box .el-button--primary:hover {
  background-color: #f04444 !important;
  border-color: #f04444 !important;
}
</style>
